// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { TransferInventoryContext } from '@/items/contexts/transfer-inventory-context';
import { useContext } from 'react';

/**
 * Hook to access the transfer inventory context.
 */
export function useTransferInventory() {
  const context = useContext(TransferInventoryContext);

  if (!context) {
    throw new Error(
      'useTransferInventory must be used within a TransferInventoryProvider'
    );
  }

  return context;
}
